// define:{
//     process.env.LINX_CLIENT_ID:'68747470733A2E2E7472616E736665722E776562332D74702E6E6574',
//     process.env.LINX_REDIRECT_URI:'https://transfer.web3-tp.net'
// }

import $ from 'jquery'

let PROJECTNAME = ''
let LINXCLIENTID = ''
let LINXREDIRECTURI = ''
let LINXMARKETNAME = ''
let LINXMARKELINXCLIENTSECRETTNAME = ''
let cardurls=''




$.ajax({
    type: 'get',
    async: false,
    url: '/ip/ip.json',
    data: {},
    success: (res) => {
        // alert(JSON.stringify(res))
       
         PROJECTNAME = res.PROJECT_NAME
         LINXCLIENTID = res.LINX_CLIENT_ID
         LINXREDIRECTURI = res.LINX_REDIRECT_URI
         LINXMARKETNAME = res.LINX_MARKET_NAME
         LINXMARKELINXCLIENTSECRETTNAME = res.LINX_CLIENT_SECRET
         cardurls=res.cardurl

    }
})


export const cardurl = cardurls;
// export const PROJECT_NAME = 'TP_Swap';
export const PROJECT_NAME = PROJECTNAME;


// export const LINX_CLIENT_ID = '68747470733A2F2F6576656E74676F2E776562332D74702E6E6574'//process.env.LINX_CLIENT_ID
export const LINX_CLIENT_ID = LINXCLIENTID//process.env.LINX_CLIENT_ID

// export const LINX_CLIENT_ID = '68747470733A2F2F627573696E657373636172642E776562332D74702E6E6574'//process.env.LINX_CLIENT_ID

// export const LINX_REDIRECT_URI = 'https://transfer.web3-tp.net'//process.env.LINX_CLIENT_URI

// export const LINX_REDIRECT_URI = 'https://eventgo.web3-tp.net'//process.env.LINX_CLIENT_URI
export const LINX_REDIRECT_URI = LINXREDIRECTURI//process.env.LINX_CLIENT_URI

// export const LINX_REDIRECT_URI = 'https://businesscard.web3-tp.net'//process.env.LINX_CLIENT_URI

// export const LINX_MARKET_NAME = 'transfer-web3-tp-net'//process.env.LINX_MARKET_NAME
export const LINX_MARKET_NAME =LINXMARKETNAME//process.env.LINX_MARKET_NAME

// export const LINX_CLIENT_SECRET = 'b5135ad6-4e8f-4e61-a710-7cc88ca657d9'//process.env.LINX_CLIENT_SECRET
export const LINX_CLIENT_SECRET = LINXMARKELINXCLIENTSECRETTNAME


export const LINX_AUTH_INFO = {
    clientId: LINX_CLIENT_ID,
    redirectUri: LINX_REDIRECT_URI
}

export const LOCAL_USER_TOKEN = PROJECT_NAME + '_User_Token';

export const CLIENT_PRE_PATH = PROJECT_NAME + '_PRE_PATH';

export const LOCAL_USER_INFO = PROJECT_NAME + '_Local_User';

export const AUTH_USER_INFO = PROJECT_NAME + '_Auth_User';

export const LOCAL_LOGIN_TYPE = PROJECT_NAME + '_LOGIN_TYPE';